import React from "react";
import { PaperLayoutVNext } from "~/components/PaperLayout/PaperLayoutVNext";
import type { Level2PageLayoutProps } from "~/routing/pageRegistrations/Level2PageLayoutProps";
import { ProjectPageTitleAccessory } from "./ProjectPageTitleAccessory";
export type ProjectPageLayoutProps = Omit<Level2PageLayoutProps, "titleAccessory">;
export function ProjectPaperLayout(props: ProjectPageLayoutProps) {
    return <PaperLayoutVNext {...props} titleAccessory={<ProjectPageTitleAccessory />}/>;
}
